/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

const MAXIMUM_EVENT_CLICK = 'MAXIMUM_EVENT_CLICK';
const MINIMUM_EVENT_CLICK = 'MINIMUM_EVENT_CLICK';
const MAX_PERCENT = 1;
const MIN_PERCENT = 0;

const keyCode = {
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  pageUp: 33,
  pageDown: 34,
  end: 35,
  home: 36
};

const percentToValue = (percent, max, min) => (max - min) * percent + min;

const valueToPercent = (value, max, min) => ((value - min) * 100) / (max - min);

const getPercentByClientDisplacement = ({
  eventType,
  client,
  sliderContainer,
  isVertical
}) => {
  switch (eventType) {
    case MINIMUM_EVENT_CLICK:
      return MIN_PERCENT;
    case MAXIMUM_EVENT_CLICK:
      return MAX_PERCENT;
    default: {
      const { width, left, height, top } =
        sliderContainer.current.getBoundingClientRect();
      if (isVertical) {
        const clientDisplacement = client - top;
        return 1 - clientDisplacement / height;
      }
      const clientDisplacement = client - left;
      return clientDisplacement / width;
    }
  }
};

export {
  getPercentByClientDisplacement,
  MAXIMUM_EVENT_CLICK,
  MINIMUM_EVENT_CLICK,
  percentToValue,
  keyCode,
  valueToPercent
};
